import { proxy } from "valtio";
import type { UserDetails, Users } from "./hooks/userSearch";

export type UserSearchFilters = {
  language: string;
  minFollowers: string;
  minRepos: string;
  accountType: "" | "user" | "org";
  sort: "" | "followers" | "repositories" | "joined";
};

export type UserSearchStore = {
  userLocation: string;
  filters: UserSearchFilters;
  users?: Users;
  userDetails: Record<string, UserDetails | undefined>;
  loadingUserDetails: Record<string, boolean | undefined>;
  userDetailsError: Record<string, string | undefined>;
  pageCount: number;
  totalUsersCount: number;
  page: number;
  error: any;
};

export const store = proxy<UserSearchStore>({
  userLocation: "",
  filters: {
    language: "",
    minFollowers: "",
    minRepos: "",
    accountType: "",
    sort: "",
  },
  users: [],
  userDetails: {},
  loadingUserDetails: {},
  userDetailsError: {},
  pageCount: 0,
  totalUsersCount: 0,
  page: 1,
  error: "",
});

export default store;
